module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-4.c757f0f0.jpg";